// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"73":"db9e3979","242":"7bc8a509","254":"b0b012c3","508":"4ac95155","519":"9ace9f0f","645":"7bb1e173","668":"a134d618","977":"257532ad","981":"2e6ba43c"}[chunkId] + ".js";
};